import i18next from 'i18next';
import { string } from 'prop-types';
import React from 'react';

import styles from '../../styles.module.scss';

const DiscountCoupon = ({ code }) => (
  <div className={`m-top-1 m-left-2 m-right-2 ${styles.border}`}>
    <div className="row middle space-between">
      <div className={styles.clientTitle}>
        <span className="bold font-size-14">{i18next.t('OrdersDetails:discountCoupon')}</span>
      </div>
      <div>
        <span className="font-size-14">{code}</span>
      </div>
    </div>
  </div>
);

DiscountCoupon.propTypes = {
  code: string.isRequired
};

export default DiscountCoupon;
